import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface AiConsentState {
  hasConsented: boolean;
  setConsented: () => void;
}

export const useAiConsentStore = create<AiConsentState>()(
  persist(
    (set) => ({
      hasConsented: false,
      setConsented: () => set({ hasConsented: true }),
    }),
    {
      name: 'ai-consent-store',
      storage: createJSONStorage(() => AsyncStorage),
      version: 1,
    }
  )
);
